<script>
import store from '../store';
import { registerSegmentAnalytics } from '../helpers/segment';

export default {
  name: 'Home',
  mounted() {
    // eslint-disable-next-line
    const { id, userName, email, name: teamName } = store.state.login;
    registerSegmentAnalytics({
      user_id: id,
      email,
      userName,
      teamName,
    });
  },
};
</script>

<template>
  <div class="p-4">
    There are no roulettes. Use the "Create New" button on the left to create your first roulette.
  </div>
</template>
